export const ReleaseInfo = Object.freeze({
  releaseVersion: '2026.2.15-1247.13',
  commitId: '36835adef6c2969c10ea6d4cb5b8c0f39cec21e4',
  commitTime: '2026-02-15T12:47:13.000Z',
});
